









































import { Vue, Component } from "vue-property-decorator";
import UKHD from "@/components/Icons/UKHD.vue";

@Component({
  components: {
    UKHD,
  },
})
export default class Navbar extends Vue {
  private menuOpen = false;
  private dropdownOpen = false;
}
